import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

const gradientButtonStyles = css`
  background-image: linear-gradient(
    to right,
    #ffff 0%,
    #f40012 60%,
    #ffff 100%
  );
  color: black;
  border: none;
  border-radius: 8px;
  background-size: 200% auto;

  &:hover {
    background-position: right center;
    transform: scale(1.1);
    ${'' /* color: black; */}
  }
`;

const buttonStyles = css`
  background-color: black;
  color: white;

  border-radius: 8px;

  &:hover {
    background-color: white;
    color: black;
    border: 1px solid black;
    transform: scale(1.1);
  }
  &:active {
    transform: scale(0.95);
  }
`;

const invertedButtonStyles = css`
  background-color: white;
  color: black;
  border: 1px solid black;
  border-radius: 8px;

  &:hover {
    background-color: black;
    color: white;
    border: none;
  }
`;

const googleSignInStyles = css`
  background-color: #4285f4;
  color: white;
  border-radius: 8px;

  &:hover {
    background-color: #357ae8;
    border: none;
  }
  @media screen and (max-width: 1000px) {
    font-size: 12px;
  }
  @media screen and (max-width: 600px) {
    font-size: 10px;
  }
`;

const getButtonStyles = (props) => {
  if (props.isGoogleSignIn) {
    return googleSignInStyles;
  } else if (props.isGradient) {
    return gradientButtonStyles;
  }

  return props.inverted ? invertedButtonStyles : buttonStyles;
};

export const CustomButtonContainer = styled(motion.button)`
  min-width: 165px;
  width: auto;
  height: 50px;
  letter-spacing: 0.5px;
  line-height: 50px;
  padding: 0 35px 0 35px;
  font-size: 15px;
  background-color: black;
  color: white;
  text-transform: uppercase;
  /* font-family: "Open Sans Condensed"; */\
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: bolder;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  ${getButtonStyles}
`;
